import React, { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import InputBase from '@mui/material/InputBase';
// import Divider from '@mui/material/Divider';
// import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import TablePaymentList from '../components/DetailMerchant/TablePaymentList';
import api from '../utils/functions/api';
import TableConfigList from '../components/DetailMerchant/TableConfigList';
import { Grid, Typography } from '@mui/material'; // Responsive
import exportExcel from '../utils/functions/exportExcel';
import jwtDecode from 'jwt-decode';
import { getStorage } from '../utils/functions/localstorage';


import {
  initializeSocket,
  getSocket,
  disconnectSocket,
} from '../components/Socket/SocketComponent';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from '../utils/functions/api';
import PaymentListApi from '../service/payment.api';

const textFieldStyles = {
  '& fieldset': {
    borderRadius: 30,
  },
};

function PaymentListMerchant() {
  const [paymentList, setPaymentList] = useState([]);
  // console.log("🚀 ~ PaymentListMerchant ~ paymentList:", paymentList)
  const [roleMerchant, setRoleMerchant] = useState('MERCHANT');
  const [page, setPage] = useState(0);
  // console.log("🚀 ~ PaymentListMerchant ~ page:", page)
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [sort, setSort] = useState({ direction: '', column: null });
  const [isLinearLoading, setIsLinearLoading] = useState(false);
  const [haveReceipt, setHaveReceipt] = useState(false);
  const [havePdf, setHavePdf] = useState(false);

  const decoded = jwtDecode(getStorage('token'));
  const isJV = decoded.IS_JV;

  const getPaymentList = async () => {
    const start = startDate === null ? '' : dayjs(startDate).format('YYYYMMDDHHmmss');
    const end = endDate === null ? '' : dayjs(endDate).endOf('day').format('YYYYMMDDHHmmss');
    const sortBy = sort.column ? `${sort.column}:${sort.direction}` : '';

    try {
      setIsLinearLoading(true);
      const resp = await PaymentListApi.getPaymentListApi(roleMerchant, start, end, page, rowsPerPage, search, sortBy);
      setPaymentList(resp.data || []);
      setTotal(resp.total || 0);
      setHaveReceipt(resp.have_receipt);
      setHavePdf(resp.have_pdf);
      // console.log('data', data);
    } catch (e) {
      throw new Error(e);
    } finally {
      setIsLinearLoading(false);
    }
  };

  const onClickSearch = () => {
    getPaymentList();
  };

  const handleKeyEnter = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      getPaymentList();
    }
  };

  const handleExportExcel = async () => {
    const columns = [
      { header: 'เลขที่ใบแจ้งหนี้', key: 'invoice_no', width: 20 },
      { header: 'ชื่อผู้ใช้บริการ', key: 'so_name', width: 15 },
      { header: 'รายการ', key: 'descriptions', width: 25 },
      { header: 'วันที่ชำระเงิน', key: 'pay_date', width: 25 },
      { header: 'ยอดรับชำระ', key: 'total_amount', width: 25 },
      { header: 'ช่องทางการชำระเงิน', key: 'pay_type', width: 25 },
      { header: 'เลขที่อ้างอิงการชำระเงิน', key: 'payment_reference_id', width: 25 },
      { header: 'เลขอ้างอิงคำสั่งรับเงิน', key: 'order_id', width: 25 },
    ];

    if(isJV) {
      columns.splice(1, 0 ,{ header: 'รหัสลูกค้า', key: 'customer_code', width: 25 });
    }
    
    const start = startDate === null ? '' : dayjs(startDate).format('YYYYMMDDHHmmss');
    const end = endDate === null ? '' : dayjs(endDate).endOf('day').format('YYYYMMDDHHmmss');
    const sortBy = sort.column ? `${sort.column}:${sort.direction}` : '';
    const resp = await PaymentListApi.getPaymentListApi(roleMerchant, start, end, 0, 99999, search, sortBy);
    const data = resp?.data || [];
    await exportExcel(data, 'รายงานการชำระเงิน.xlsx' , columns);
  };

  useEffect(() => {
    getPaymentList();
    return () => {};
  }, [rowsPerPage, page, sort]);

  useEffect(() => {
    const socket = initializeSocket();

    socket.on('paymentSuccess', (data) => {
      console.log('Payment Success Event:', data);

      getPaymentList();

      // Show Toast Notification
      toast.success(
        <div style={{ textAlign: 'left' }}>
          <p
            style={{
              margin: 0,
              fontWeight: 'bold',
              fontSize: '16px',
              color: '#333',
              whiteSpace: 'nowrap',
            }}
          >
            รายการ {data.invoiceNo}{' '}
            <span
              style={{
                fontWeight: 'normal',
                fontSize: '12px',
                color: '#777',
              }}
            >
              ชำระเงินเรียบร้อย
            </span>
          </p>
          <p style={{ margin: '4px 0', fontSize: '14px', color: '#555' }}>
            ฿{data.amount}{' '}
            <span style={{ fontSize: '12px', color: '#777' }}>
              - {new Date(data.paymentDate).toLocaleString()}
            </span>
          </p>
        </div>,
        {
          position: 'top-right',
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        },
      );
    });

    return () => {
      // Remove event listener on unmount
      socket.off('paymentSuccess');
      disconnectSocket();
    };
  }, []);

  return (
    <div>
      <ToastContainer />

      <div className="my-2 ml-2">
        <div className="text-lg font-light flex items-center ">
          <div className="py-6 text-xl">ประวัติการชำระเงิน</div>
        </div>
        {/* <div className=" flex ">
          <div className="md:w-[15%]">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="วันที่"
                value={startDate}
                inputFormat="DD/MM/YYYY"
                maxDate={endDate}
                onChange={(newValue) => {
                  setStartDate(newValue);
                }}
                renderInput={(params) => (
                  <TextField
                    sx={{ ...textFieldStyles }}
                    size="small"
                    {...params}
                  />
                )}
              />
            </LocalizationProvider>
          </div>

          <div className="md:w-[15%] ml-2">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              {startDate === null || startDate === '' ? (
                <DatePicker
                  disabled
                  label="ถึง"
                  inputFormat="DD/MM/YYYY"
                  value={endDate}
                  minDate={startDate}
                  onChange={(newValue) => {
                    setEndDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      sx={{ ...textFieldStyles }}
                      {...params}
                    />
                  )}
                />
              ) : (
                <DatePicker
                  label="ถึง"
                  inputFormat="DD/MM/YYYY"
                  value={endDate}
                  minDate={startDate}
                  onChange={(newValue) => {
                    setEndDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      size="small"
                      sx={{ ...textFieldStyles }}
                      {...params}
                    />
                  )}
                />
              )}
            </LocalizationProvider>
          </div>
          <div className="ml-2  md:w-[30%] ">
            <Paper
              component="form"
              sx={{
                pl: 2,
                display: 'flex',
                alignItems: 'center',
                borderRadius: '20px',
              }}
            >
              <InputBase
                sx={{ ml: 1, flex: 1 }}
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                }}
                onKeyDown={handleKeyEnter}
                placeholder="ค้นหา"
              />
              <div className="p-[8px]">
                <SearchIcon
                  sx={{ fontSize: '22px', mr: 1, color: '#757575' }}
                />
              </div>
            </Paper>
          </div>
          <div className="ml-2 self-center">
            <Button
              variant="contained"
              sx={{
                background: 'primary',
                color: 'white',
                borderRadius: '20px',
              }}
              onClick={() => {
                onClickSearch();
              }}
            >
              ค้นหา
            </Button>
          </div>
        </div> */}
        <div>
          <Grid container spacing={1}>
            <Grid item xs={6} md={3} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="วันที่"
                  value={startDate}
                  inputFormat="DD/MM/YYYY"
                  maxDate={endDate}
                  onChange={(newValue) => {
                    setStartDate(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      sx={{ ...textFieldStyles }}
                      size="small"
                      {...params}
                    />
                  )}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6} md={3} lg={2}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                {startDate === null || startDate === '' ? (
                  <DatePicker
                    disabled
                    label="ถึง"
                    inputFormat="DD/MM/YYYY"
                    value={endDate}
                    minDate={startDate}
                    onChange={(newValue) => {
                      setEndDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        sx={{ ...textFieldStyles }}
                        {...params}
                      />
                    )}
                  />
                ) : (
                  <DatePicker
                    label="ถึง"
                    inputFormat="DD/MM/YYYY"
                    value={endDate}
                    minDate={startDate}
                    onChange={(newValue) => {
                      setEndDate(newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        size="small"
                        sx={{ ...textFieldStyles }}
                        {...params}
                      />
                    )}
                  />
                )}
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} md={4} lg={4}>
              <Paper
                component="form"
                sx={{
                  pl: 2,
                  display: 'flex',
                  alignItems: 'center',
                  borderRadius: '20px',
                  justifyContent: 'space-between',
                  boxShadow: 'none',
                  border: '1px solid #CCCCCC',
                }}
              >
                <InputBase
                  value={search}
                  onChange={(e) => {
                    setSearch(e.target.value);
                  }}
                  onKeyDown={handleKeyEnter}
                  fullWidth
                  placeholder="ค้นหา"
                />
                <div className="p-[8px]">
                  <SearchIcon
                    sx={{ fontSize: '22px', mr: 1, color: '#757575' }}
                  />
                </div>
              </Paper>
            </Grid>
            <Grid item xs={3} md={2} lg={1}>
              <div className="">
                <Button
                  variant="contained"
                  sx={{
                    background: 'primary',
                    color: 'white',
                    borderRadius: '20px',
                  }}
                  onClick={() => {
                    onClickSearch();
                  }}
                >
                  ค้นหา
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      <TablePaymentList
        paymentList={paymentList}
        rowsPerPage={rowsPerPage}
        page={page}
        total={total}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        sort={sort}
        setSort={setSort}
        isLinearLoading={isLinearLoading}
        haveReceipt={haveReceipt}
        havePdf={havePdf}
        handleExportExcel={handleExportExcel}
      />
    </div>
  );
}

export default PaymentListMerchant;
